import React, { useState } from 'react';
import { Link } from '@reach/router';

const MethodItem = ({ index, methodName, web3URL, web3Lib }) => {

  return (

    <l1>
      <Link
        to={`/${web3URL}/${web3Lib}/${methodName}`}
      >
        <p class="text-secondary">{methodName}</p>
        <hr />
      </Link>
    </l1>
  );
};

const MethodList = ({ web3Lib, web3URL }) => {

  const availableMethods = [
    'eth_hashrate',
    'eth_gasPrice',
    'eth_blockNumber',
    'eth_getBalance',
    'eth_syncing',
    'eth_getStorageAt',
    'eth_getTransactionCount',
    'eth_getBlockTransactionCountByHash',
    'eth_getBlockTransactionCountByNumber',
    'eth_getCode',
    'eth_sendRawTransaction',
    'eth_getBlockByHash',
    'eth_getBlockByNumber',
    'eth_getTransactionByHash',
    'eth_getTransactionByBlockHashAndIndex',
    'eth_getTransactionByBlockNumberAndIndex',
    'eth_getTransactionReceipt',
    'eth_getUncleByBlockHashAndIndex',
    'eth_getUncleByBlockNumberAndIndex',
    'eth_getUncleCountByBlockHash',
    'eth_getUncleCountByBlockNumber',
  ];

  const [foundmethods, setFoundMethods] = useState(availableMethods);

  const filter = (e) => {
    const search = e.target.value;

    if (search !== '') {
      const searchMethods = availableMethods.filter((user) => {
        return user.toLowerCase().includes(search.toLowerCase());
      });
      setFoundMethods(searchMethods);
    } else {
      setFoundMethods(availableMethods);
    }

  };

  return (
    <div>

      {/* Search bar */}
      <input
        type="text"
        class="form-control"
        onChange={filter}
        placeholder="Search for Method Name"
      />

      {/* Method list */}
      <div class="overflow-auto h-250rem mt-3 mb-3">
        <div class="p-3 rounded" style={{ backgroundColor: "#f8f8ff" }}>
          <div className="user-list">
            {foundmethods && foundmethods.length > 0 ? (
              foundmethods.map((user) => (
                <l1>
                  <MethodItem
                    key={user}
                    methodName={user}
                    // prevent crashing on null URL
                    // set to https://bsc-mainnet.web3api.com/v1/YOUR-API-KEY by default 
                    web3URL={web3URL ? web3URL : "aHR0cHM6Ly9ic2MtbWFpbm5ldC53ZWIzYXBpLmNvbS92MS9ZT1VSLUFQSS1LRVk="}
                    web3Lib={web3Lib}
                  />
                </l1>
              ))
            ) : (
              <p class="text-secondary">No search methods found.</p>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

export { MethodList };
